import { render } from "./CommentsPanel.vue?vue&type=template&id=365b74fb&scoped=true"
import script from "./CommentsPanel.vue?vue&type=script&lang=js"
export * from "./CommentsPanel.vue?vue&type=script&lang=js"

import "./CommentsPanel.vue?vue&type=style&index=0&id=365b74fb&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365b74fb"]])

export default __exports__